import React, {Component} from 'react'
import { observer } from 'mobx-react'
import liqpayGeneratorStore from "../../store/LiqpayGeneratorStore";
import {BL_BRANDS, BL_ORDER_STATUSES, BL_ORDER_TYPES} from "../../config/constants";
import LiqpaySumInput from "./LiqpaySumInput";

@observer
class LiqpayOverlay extends Component {
    BrandList() {
        return  BL_BRANDS.map(
            (brand) =>
                <div className='col-6 mb-4' key={brand.key}>
                    <div className='brand-item rounded shadow' onClick={() => liqpayGeneratorStore.loadTerminals(brand.key)}>
                        <div className='inner'>
                            <img src={brand.logo} alt={brand.title} />
                        </div>
                    </div>
                </div>
        );
    }

    TerminalsList() {
        return  liqpayGeneratorStore.terminals.map(
            (terminal) =>
                <div className='col-12' >
                    <div className='terminal-item rounded shadow' onClick={() => liqpayGeneratorStore.loadOrderTypes(terminal.iiko_id)}>
                        <div className='inner'>
                            <div>{ terminal.name }</div>
                            <div className="opacity-25">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     className="bi bi-arrow-right" viewBox="0 0 16 16">
                                    <path fillRule="evenodd"
                                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }

    OrdersList() {
        if(liqpayGeneratorStore.orders == null)
            return <div className='col-12' >На цьому терміналі наразі немає замовлень</div>
        return  liqpayGeneratorStore.orders.map(
            (order) =>
                <div className='col-12' >
                    <div className='terminal-item rounded shadow' onClick={() => liqpayGeneratorStore.loadAccept(order)}>
                        <div className='inner'>
                            <div className="order-number">
                                <b>#{ order.order.number }</b>
                                <span className={`order-status ${order.order.status}`}>{ BL_ORDER_STATUSES[order.order.status] }</span>
                            </div>
                            <div>
                                { order.order.sum }₴
                            </div>
                        </div>
                        <div className="separator"></div>
                        <div className="inner bottom">
                            { order.order.marketingSource != null &&
                                <span className="badge text-bg-light">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-shop-window"
                                         viewBox="0 0 16 16">
                                      <path
                                          d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5m2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5"/>
                                    </svg>
                                    <span>{order.order.marketingSource.name}</span>
                                </span>
                            }
                            { order.order.operator != null &&
                                <span className="badge text-bg-warning">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-check"
                                         viewBox="0 0 16 16">
                                      <path
                                          d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                                      <path
                                          d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                                    </svg>
                                    <span>{order.order.operator.name}</span>
                                </span>
                            }
                        </div>
                    </div>
                </div>
        );
    }

    OrderTypesList() {
        return BL_ORDER_TYPES.map(
            (type) =>
                <div className='col-12'>
                    <div className='terminal-item rounded shadow'
                         onClick={() => liqpayGeneratorStore.loadSumInput(type.key)}>
                        <div className='inner'>
                            <div>{type.title}</div>
                            <div>
                            <img src={type.icon}/>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }


    render() {
        switch (liqpayGeneratorStore.step) {
            case 'brand':
                return (
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 offset-0 col-md-6 offset-md-3' >
                                <div className='row' >
                                    {this.BrandList()}
                                </div>
                            </div>
                        </div>
                        <div className="separator"></div>
                        <div className='col-12 offset-0 col-md-6 offset-md-3'>
                            <div className="coupon-row">
                                <div className="coupon-icon shadow">
                                    <img src="/assets/img/logos/bagatolososia.svg" alt="" />
                                </div>

                                <input
                                    className="coupon-input"
                                    type="text"
                                    placeholder="код купона"
                                    value={liqpayGeneratorStore.couponCode}
                                    onChange={(e) => liqpayGeneratorStore.setCouponCode(e.target.value)}
                                />

                                <button
                                    className="coupon-button"
                                    onClick={() => {
                                        liqpayGeneratorStore.requestCouponAPI(liqpayGeneratorStore.couponCode)
                                    }}
                                    disabled={!liqpayGeneratorStore.couponCode.trim()}
                                >перевірити</button>
                            </div>
                            <div className="hint">* наразі перевірка купонів працює лише для купонів БагатоЛосося</div>
                        </div>
                    </div>
                )

            case 'terminal':
                return (
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 offset-0 col-md-6 offset-md-3'>
                                <div className='row'>
                                    {this.TerminalsList()}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            case 'order_type':
                return (
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 offset-0 col-md-6 offset-md-3'>
                                <div className='row'>
                                    {this.OrderTypesList()}
                                    <div className="col-12 separator"></div>
                                    <div className='col-12' >
                                        <div className='terminal-item rounded shadow' onClick={() => liqpayGeneratorStore.loadOrders()}>
                                            <div className='inner'>
                                                <div>Існуюче замовлення</div>
                                                <div>
                                                    <img src="/assets/img/icons/bag.png" />
                                                </div>
                                            </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )
            case 'sum':
                return (
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 offset-0 col-md-6 offset-md-3'>
                                { liqpayGeneratorStore.orderSumMode === 'manual' &&
                                  <LiqpaySumInput />
                                }
                                { liqpayGeneratorStore.orderSumMode === 'auto' &&
                                    this.OrdersList()
                                }
                            </div>
                        </div>
                    </div>
                )
            case 'accept':
                const store = liqpayGeneratorStore
                const brand = BL_BRANDS.find(x => x.key === store.brand)
                const terminal = store.terminals.find(x => x.iiko_id === store.terminalId)
                const orderType = BL_ORDER_TYPES.find(x => x.key === store.orderType)
                const order = store.order
                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'UAH'
                })
                const sum = formatter.format(store.sum)
                return (
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 offset-0 col-md-6 offset-md-3'>
                                <div className='accept-card shadow-lg p-4'>
                                    <div className='accept-item'>
                                        <img src={brand.logo}/>
                                        <div>{brand.title}</div>
                                    </div>
                                    <div className='accept-item'>
                                        <div>{terminal.name}</div>
                                    </div>
                                    <div className='accept-item'>
                                        <img src={orderType.icon}/>
                                        <div>{orderType.title}</div>
                                    </div>
                                    { liqpayGeneratorStore.orderSumMode === 'manual' &&
                                    <div className='accept-item sum'>
                                        <div>{sum}</div>
                                    </div>
                                    }
                                    { liqpayGeneratorStore.orderSumMode === 'auto' &&
                                        <div className='terminal-item rounded shadow' >
                                            <div className='inner'>
                                                <div className="order-number">
                                                    <b>#{ order.order.number }</b>
                                                    <span className={`order-status ${order.order.status}`}>{ BL_ORDER_STATUSES[order.order.status] }</span>
                                                </div>
                                                <div>
                                                    { order.order.sum }₴
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='accept-accept' onClick={() => liqpayGeneratorStore.loadLink()}>
                                    <button>Отримати посилання</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            case 'link':
                return(
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 offset-0 col-md-6 offset-md-3'>
                                <div className='link-card shadow'>
                                    <div className='link-card__link' >
                                        {liqpayGeneratorStore.link}
                                    </div>
                                    { !liqpayGeneratorStore.linkCopied &&
                                        <button
                                            onClick={()=>liqpayGeneratorStore.copyLink()}
                                        >

                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor" className="bi bi-clipboard" viewBox="0 0 16 16">
                                                <path
                                                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
                                                <path
                                                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
                                            </svg>
                                            Копіювати
                                        </button>
                                    }
                                    { liqpayGeneratorStore.linkCopied &&
                                        <button
                                            className='copied'
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor" className="bi bi-clipboard-check"
                                                 viewBox="0 0 16 16">
                                                <path fill-rule="evenodd"
                                                      d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                                                <path
                                                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
                                                <path
                                                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
                                            </svg>
                                            Скопійовано
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )
        }
    }
}

export default LiqpayOverlay
